import { Route } from '@angular/router';

export const clientsRoutes: Route[] = [
  /* { path: '', pathMatch: 'full', component: InsertYourComponentHere } */
];
